import { SceneAssetKind } from '../../types/scene-assets/sceneAssetKinds.js';

/**
 * How much of a reference-image budget one element is worth, relative to the
 * others competing for it.
 *
 * A WEIGHT IS A SHARE, NEVER A COUNT. The actual number of images an element
 * receives depends on how many elements are competing and how many slots the
 * model offers, and every element keeps a floor of one whatever its weight.
 *
 * The ladder, set by James on 2026-08-05:
 *
 *   hero       5   the subject of the campaign, whatever kind it is
 *   character  3   identity needs several angles to survive across shots
 *   anything   1   a prop, a location or a brand mark usually reads from one
 *
 * HERO REPLACES THE KIND WEIGHT, it never stacks on it: a hero character is 5,
 * not 8. Two systems deciding one number is the second-owner defect this repo
 * keeps paying for, so there is exactly one function and hero is one branch of
 * it.
 *
 * ⚠️ Worth knowing before tuning these numbers. On small budgets the floors
 * dominate and the ratio barely expresses itself -- at 8 or 9 slots, hero 5 and
 * hero 4 allocate identically. The separation only appears at 10 slots and above.
 * If a change is meant to make heroes visibly dominate on a small-budget model,
 * the honest lever is the floor, not this ladder.
 */
export function getElementReferenceWeight({ kind, hero } = {}) {
  if (hero === true) return 5;
  return kind === SceneAssetKind.CHARACTER ? 3 : 1;
}

export default getElementReferenceWeight;
